import type { Category, ProjectsDoc } from '../../domain/types';
import { resolveCategory } from '../../db/categories';
import { findProject } from '../../db/projects';

/**
 * 記事につく札。プロジェクトが設定されていれば、カテゴリの代わりにプロジェクト名を出す。
 */
export function EntryBadge({
  categoryId,
  projectId,
  categories,
  projects,
}: {
  categoryId: string | null;
  projectId?: string | null;
  categories: Map<string, Category>;
  projects?: ProjectsDoc;
}) {
  const project = projects ? findProject(projects, projectId) : undefined;
  if (project) {
    return (
      <span className="badge badge-project" style={{ background: project.color }}>
        ◆ {project.name}
      </span>
    );
  }
  const c = resolveCategory(categories, categoryId);
  return (
    <span className="badge" style={{ background: c.color }}>
      {c.name}
    </span>
  );
}
